<template>
    <div :class="$style.PageAnalyze">
        <Container :class="[$style.container]">
            <WBBreadcrumb :breadcrumbs="breadcrumbs" />

            <h1 class="h2"
                :class="[$style.title]"
            >
                Анализ SKU
            </h1>

            <div :class="$style.row">
                <div :class="$style.date">
                    Фильтр по дате
                </div>

                <UiButton color="primary"
                          :class="$style.button"
                          @click="handleClick"
                >
                    Провести анализ
                </UiButton>
            </div>

            <AnalyzeSkuTable :class="$style.table" />
        </Container>
    </div>
</template>

<script setup>
    import Container from '~/src/shared/components/common/Container/Container.vue'
    import AnalyzeSkuTable from '~/src/shared/components/pages/analyze/AnalyzeSkuTable.vue'
    import { useModalStore } from '~/src/shared/pinia/modal/useModalStore'

    const AnalyzeSkuModal = defineAsyncComponent(() => import('~/src/shared/components/layout/modals/analyze/AnalyzeSkuModal.vue'))

    const modal = useModalStore()

    const breadcrumbs = [
        {
            title: 'Инструменты',
            href: '/instruments',
        },
        {
            title: 'Анализ SKU',
            href: '',
        },
    ]

    const handleClick = () => {
        modal.open(AnalyzeSkuModal, {
            modal: {
                position: 'default',
            },
            props: {},
        })
    }
</script>

<style
    lang="scss"
    module
>
    .PageAnalyze {
        //
    }

    .table {
        margin-top: 3.2rem;

        @include respond-to(tablet) {
            margin-top: 2.8rem;
        }

        @include respond-to(mobile) {
            margin-top: 2rem;
        }
    }

    .row {
        display: flex;
        align-items: center;
    }

    .button {
        margin-left: auto;
    }
</style>
